import Vue from 'vue'
import VueAppInsights from 'vue-application-insights'
import router from '@/router/index'

if (location.hostname !== "localhost" && location.hostname !== "127.0.0.1") {
    Vue.use(VueAppInsights, {
        id: '9fc6f97b-7cea-4277-b968-9438160b7e94',
        router
    })
}